const keys = {
    GET_PAYMENTS: '/payments',
    POST_PAYMENT: '/payment',
    POST_VERIFY_PAYMENT: (gateway: string) => `/payment/verify/${gateway}`
};

export default keys;

